import React, {Component} from "react";
import {I18n} from "../../../I18n/components/loan";
import swal from "sweetalert";

class LoanOrderReturn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sum: null,
        };
    }

    componentDidMount() {
        const {sum} = this.props;
        this.setSum(sum);
    }

    onInputChange = event => {
        const sum = event.target.value;

        let parts = String(sum).split('.');
        if (parts.length > 1 && parts[1].length > 2) {
            return;
        }

        this.setSum(sum)
    }

    setSum = sum => {
        this.setState({sum},
            () => swal.setActionValue({
                confirm: this.state.sum
            }));
    }

    render() {
        const {lang} = this.props;
        const {sum} = this.state;
        return (
            <div className="text-center">
                <label>{I18n[lang].sum}</label>
                <input
                    className="ml-2 w-25 text-center"
                    type="number"
                    name="sum"
                    value={sum}
                    onChange={this.onInputChange.bind(this)}
                />
            </div>
        )
    }
}

export default LoanOrderReturn;



// WEBPACK FOOTER //
// ./src/components/Loan/Order/LoanOrderReturn.js